import type { TMessages } from '@/types/TMessages'

export const messages = {
  error: 'Что-то пошло не так',
  action: 'Понятно',
} as const satisfies TMessages
